import { Card, CardContent, Button, Box } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

type Props = {
    searchLabel: string;
    search: string;
    handleReset: () => void;
    setSearchKeyword: (e: string) => void;
}
const BordFilterCard = ({ searchLabel, search, handleReset, setSearchKeyword }: Props) => {
    return (
        <Card
            sx={{
                height: '100%',
                cursor: 'pointer',
                boxShadow: 2,
                padding: 2,
                mb: 3,
                transition: 'all 0.3s ease',
                '&:hover': {
                    boxShadow: 4,
                },
            }}
        >
            <CardContent>
                <div className="grid grid-cols-1 gap-4 md:grid-cols-5">
                    <div>
                        <label className="block mb-1 text-sm font-medium text-gray-700">
                            {searchLabel}
                        </label>
                        <input
                            type="text"
                            value={search}
                            onChange={(e) => setSearchKeyword(e.target.value)}
                            placeholder="Search..."
                            className="w-full border border-gray-300 rounded-lg px-3 py-1.5 focus:outline-none focus:ring-2 focus:ring-[#026730] focus:border-transparent"
                        />
                    </div>

                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <Box display="flex" alignItems="flex-start" gap={2} width="100%">

                            <Box display="flex" alignItems="center">
                                <Button
                                    variant="outlined"
                                    size="small"
                                    onClick={handleReset}
                                    sx={{
                                        borderRadius: 2,
                                        width: '113px',
                                        marginTop: '24px',
                                    }}
                                >
                                    Reset
                                </Button>
                            </Box>
                        </Box>
                    </LocalizationProvider>
                </div>
            </CardContent>
        </Card>

    )
}

export default BordFilterCard